export default __webpack_public_path__ + "static/media/hero.d39d8752.jpg";